import React from 'react';
import styled from 'styled-components';
import {DATE_PRESETS} from '../constants/datePresets';

interface Props {
	label: string;
	from: string;
	to: string;
	onChangeFrom: (value: string) => void;
	onChangeTo: (value: string) => void;
}

const Section = styled.div`
	border-bottom: 1px solid #f1f5f9;
	padding-bottom: 12px;
`;

const SectionLabel = styled.span`
	display: block;
	margin-bottom: 8px;
	font: ${p => p.theme.ticketing.font.subheading2};
	font-weight: 500;
	color: #334155;
`;

const PresetRow = styled.div`
	display: flex;
	flex-wrap: wrap;
	gap: 4px;
	margin-bottom: 8px;
`;

const PresetButton = styled.button`
	border-radius: ${p => p.theme.ticketing.radius.full};
	border: 1px solid #e2e8f0;
	background: #ffffff;
	padding: 2px 8px;
	font: ${p => p.theme.ticketing.font.body3};
	color: #475569;
	cursor: pointer;
	transition: background-color 0.15s, border-color 0.15s;
	&:hover {
		background: #f8fafc;
		border-color: #cbd5e1;
	}
`;

const Grid = styled.div`
	display: grid;
	grid-template-columns: repeat(2, minmax(0, 1fr));
	gap: 8px;
`;

const FieldLabel = styled.label`
	display: block;
	margin-bottom: 2px;
	font: ${p => p.theme.ticketing.font.body3};
	color: #64748b;
`;

const DateInput = styled.input`
	width: 100%;
	border-radius: 6px;
	border: 1px solid #e2e8f0;
	padding: 6px 8px;
	font: ${p => p.theme.ticketing.font.subheading2};
	color: #334155;
	&:focus {
		outline: none;
		border-color: #a5b4fc;
		box-shadow: 0 0 0 1px #a5b4fc;
	}
`;

export function FilterDrawerDateRange({label, from, to, onChangeFrom, onChangeTo}: Props) {
	function applyPreset(presetId: string) {
		const preset = DATE_PRESETS.find(p => p.id === presetId);
		if (!preset) return;
		const range = preset.getRange();
		onChangeFrom(range.from);
		onChangeTo(range.to);
	}

	return (
		<Section>
			<SectionLabel>{label}</SectionLabel>
			<PresetRow>
				{DATE_PRESETS.map(preset => (
					<PresetButton key={preset.id} type="button" onClick={() => applyPreset(preset.id)}>
						{preset.label}
					</PresetButton>
				))}
			</PresetRow>
			<Grid>
				<div>
					<FieldLabel>From</FieldLabel>
					<DateInput type="date" value={from} onChange={e => onChangeFrom(e.target.value)} />
				</div>
				<div>
					<FieldLabel>To</FieldLabel>
					<DateInput type="date" value={to} onChange={e => onChangeTo(e.target.value)} />
				</div>
			</Grid>
		</Section>
	);
}
